import { ListCard } from "@hagerty/self-service-components";
import { SettingsContainer } from "../../SettingsContainer/SettingsContainer";
import styles from "./SettingsSkeleton.module.scss";

const ListCardSingleRowSkeleton = () => (
  <ListCard.Row>
    <div className={styles.sectionDetailRow}>
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
    </div>
  </ListCard.Row>
);

const ListCardDoubleRowSkeleton = () => (
  <ListCard.Row>
    <div className={styles.skeleton} />
    <div className={styles.sectionDetailRow}>
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
    </div>
  </ListCard.Row>
);

const ListCardHeaderSkeleton = () => (
  <div className={styles.container}>
    <div className={styles.skeletonHeader} />
  </div>
);

const ListCardTitleSkeleton = () => (
  <div className={styles.container}>
    <div className={styles.skeletonTitle} />
  </div>
);

export function SettingsSkeleton() {
  return (
    <SettingsContainer testid="account-settings">
      <ListCardHeaderSkeleton />
      <ListCardTitleSkeleton />
      <ListCardDoubleRowSkeleton />
      <ListCardDoubleRowSkeleton />
      <ListCardTitleSkeleton />
      <ListCardDoubleRowSkeleton />
      <ListCardDoubleRowSkeleton />
      <ListCardDoubleRowSkeleton />
      <ListCardTitleSkeleton />
      <ListCardSingleRowSkeleton />
      <ListCardSingleRowSkeleton />
      <ListCardSingleRowSkeleton />
    </SettingsContainer>
  );
}
